"use client";

import { motion } from "framer-motion";
import { Button } from "./button";
import { Input } from "../ui/input";
import Cookies from "js-cookie";
import { useState } from "react";
import { toast } from "sonner";
import { ArrowRightIcon } from "lucide-react";
import { CONSTANTS } from "@/constants/links";
const APP_SIGNUP_URL = `${process.env.NEXT_PUBLIC_APP_URL || "http://app.localhost:3000"}/sign-up`;
const COOKIE_DOMAIN = process.env.NEXT_PUBLIC_COOKIE_DOMAIN || ".localhost";

// Function to extract just the domain from a URL
const extractDomain = (input: string): string => {
  if (!input.trim()) return "";
  let url = input.trim();

  // Remove protocol if present
  url = url.replace(/^https?:\/\//, "");

  // Remove www. if present
  url = url.replace(/^www\./, "");

  // Remove any path, query params, or fragments
  url = url.split("/")[0];
  url = url.split("?")[0];
  url = url.split("#")[0];
  return url;
};
export function HeroHeading() {
  const [websiteUrl, setWebsiteUrl] = useState("");
  const handleGetLaunchPlan = (e: React.FormEvent) => {
    e.preventDefault();
    if (!websiteUrl.trim()) {
      toast.error("Please enter your website URL");
      return;
    }

    // Extract just the domain part
    const domain = extractDomain(websiteUrl);
    if (!domain) {
      toast.error("Please enter a valid website URL");
      return;
    }

    // Set cookie with just the domain (no protocol)
    Cookies.set("pending_website_url", domain, {
      path: "/",
      domain: COOKIE_DOMAIN,
      expires: 1 // Expires in 1 day
    });
    toast("Redirecting to sign up...");
    window.location.href = APP_SIGNUP_URL;
  };
  return <>
      <div className="mx-auto max-w-7xl px-6 xl:px-10">
        {/* <div className="relative flex flex-col items-center border border-red-500">
          <DotPattern width={5} height={5} />
           <div className="absolute -left-1.5 -top-1.5 h-3 w-3 bg-red-500 text-white" />
          <div className="absolute -bottom-1.5 -left-1.5 h-3 w-3 bg-red-500 text-white" />
          <div className="absolute -right-1.5 -top-1.5 h-3 w-3 bg-red-500 text-white" />
          <div className="absolute -bottom-1.5 -right-1.5 h-3 w-3 bg-red-500 text-white" /> */}

        <div className="relative z-20 mx-auto max-w-7xl rounded-[40px] py-6 md:py-10 xl:pb-5">
          <p className="md:text-md text-md text-emerald-500 lg:text-lg xl:text-2xl">
            Get your
          </p>
          <div className="text-6xl  md:text-7xl lg:text-7xl xl:text-8xl">
            <h1 className="font-semibold dark:text-white">
              First 100 Customers In Days, not months
            </h1>
            {/* <p className="font-normal md:text-3xl lg:text-4xl xl:text-5xl">
              not months
             </p> */}
          </div>
          {/* </div> */}
        </div>
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.2,
        delay: 0.5
      }} className="relative z-20 text-lg text-gray-600 dark:text-gray-200" data-sentry-element="unknown" data-sentry-source-file="hero-heading.tsx">
          {/* Your go-to-market team in a box — with all the tools you need to go
           from idea to 100 customers in days 🚀 */}
          {/* Create content for X, Product Hunt, Reddit & more. Run viral giveaways
           and get a curated list of 100+ platforms to launch on. From idea to
           100 customers - fast 🚀 */}
          Create launch content for X, Product Hunt, Reddit +more. Make promo
          videos, run viral giveaways, post on 100+ launch platforms 🚀
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.2,
        delay: 0.7
      }} className="mt-8 flex flex-wrap gap-4" data-sentry-element="unknown" data-sentry-source-file="hero-heading.tsx">
          {/* Add input field with button for visitor to enter their saas's url */}
          <form onSubmit={handleGetLaunchPlan} className="flex w-full max-w-[400px] scale-110 -space-x-px pl-4">
            <Input type="text" id="website-url" placeholder="Enter your website" className="rounded-r-none" value={websiteUrl} onChange={e => setWebsiteUrl(e.target.value)} data-sentry-element="Input" data-sentry-source-file="hero-heading.tsx" />
            <Button as="button" href={CONSTANTS.SIGNUP_LINK} type="submit" variant="primary" className="group/button flex w-auto min-w-[150px] flex-row items-center justify-center gap-1 rounded-l-none" data-sentry-element="Button" data-sentry-source-file="hero-heading.tsx">
              Start for $0{" "}
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-300 group-hover/button:translate-x-0.5" data-sentry-element="ArrowRightIcon" data-sentry-source-file="hero-heading.tsx" />
              {/* <span className="">Get Launch Plan</span> */}
            </Button>
          </form>

          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.2,
          delay: 0.5
        }} className="relative z-20 -mt-1 pl-1 text-sm text-gray-600 dark:text-gray-200" data-sentry-element="unknown" data-sentry-source-file="hero-heading.tsx">
            3-day free trial & 100% money-back guarantee, no questions asked.
          </motion.p>

          {/* <Button
            as="button"
            href={CONSTANTS.SIGNUP_LINK}
            variant="secondary"
            className="group/button flex w-auto flex-row items-center justify-center gap-1"
            disableAnimation={true}
           >
            Start for $0{" "}
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-300 group-hover/button:translate-x-0.5" />
           </Button> */}
        </motion.div>
      </div>
    </>;
}